// extracted by mini-css-extract-plugin
export default {"container":"RecordsLoader_container__np091"};